const GOOGLE_FALLBACK_DOMAIN_REGEX = /^accounts\.google\.([a-z]{2,3})$/;
export const isGoogleFallbackRedirect = domain => {
  return domain && domain.match(GOOGLE_FALLBACK_DOMAIN_REGEX);
};